import axios from 'axios';
import utils from 'axios/lib/utils';
import env from './env';
import qs from 'qs'
axios.defaults.timeout = 5000;
axios.defaults.baseURL =env.baseUrl;
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';  //此处是增加的代码，设置请求头的类型
axios.defaults.headers['Accept'] = 'application/json, text/plain, */*';  //此处是增加的代码，设置请求头的类型
const instance = axios.create({
    baseURL: env.baseUrl,
    timeout: 10000,
    transformRequest: [function (data, headers) {
        /* 把类似content-type这种改成Content-Type */
        let keys = Object.keys(headers);
        let normalizedName = 'Content-Type';
        keys.forEach(name => {
            if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
                headers[normalizedName] = headers[name];
                delete headers[name];
            }
        });
        if (utils.isFormData(data) ||
          utils.isArrayBuffer(data) ||
          utils.isStream(data) ||
          utils.isFile(data) ||
          utils.isBlob(data)
        ) {
            return data;
        }
        if (utils.isURLSearchParams(data)) {
            setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
            return data.toString();
        }
        /* 这里是重点，其他的其实可以照着axios的源码抄 */
        /* 这里就是用来解决POST提交json数据的时候是直接把整个json放在request payload中提交过去的情况
         * 这里简单处理下，把 {name: 'admin', pwd: 123}这种转换成name=admin&pwd=123就可以通过
         * x-www-form-urlencoded这种方式提交
         * */
        if (utils.isObject(data)) {
            setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
            let keys2 = Object.keys(data);
            /* 这里就是把json变成url形式，并进行encode */
            return encodeURI(keys2.map(name => `${name}=${data[name]}`).join('&'));
        }
        return data;
    }]
});
// http request 拦截器
instance.interceptors.request.use(
    config => {
        // const token = getCookie('名称');注意使用的时候需要引入cookie方法，推荐js-cookie
        // config.data = JSON.stringify(config.data);
        config.headers = {
            'Content-Type':'application/x-www-form-urlencoded;charset=UTF-8'
        }
        // if(token){
        //   config.params = {'token':token}
        // }
        return config;
    },
    error => {
        return Promise.reject(err);
    }
);


//http response 拦截器
instance.interceptors.response.use(
    response => {
        if(response.data.errCode ==2){
            router.push({
                path:"/login",
                querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
            })
        }
        return response;
    },
    error => {
        return Promise.reject(error)
    }
)


/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url,params={}){
    return new Promise((resolve,reject) => {
        instance.get(url,{
            params:params,
        })
            .then(response => {
                let result = {};
                // console.log(response)
                if(response.data == null || response.data == undefined){
                    result.status = -2002;
                    result.statusdes ='网络错误';
                    response(result);
                }
                if(response.data.Code==0){
                    result.status = 1;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }else{
                    result.status = response.data.Code;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }
                resolve(result);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url,data){
    return new Promise((resolve,reject) => {
        data = qs.stringify(data);
        instance.post(url,data)
            .then(response => {
                let result = {};
                if(response.data == null || response.data == undefined){
                    result.status = -2002;
                    result.statusdes ='网络错误';
                    response(result);
                }
                if(response.data.Code==0){
                    result.status = 1;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }else{
                    result.status = response.data.Code;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }
                resolve(result);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url,data = {}){
    return new Promise((resolve,reject) => {
        instance.patch(url,data)
            .then(response => {
                let result = {};
                if(response.data == null || response.data == undefined){
                    result.status = -2002;
                    result.statusdes ='网络错误';
                    response(result);
                }
                if(response.data.Code==0){
                    result.status = 1;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }else{
                    result.status = response.data.Code;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }
                resolve(result);
            },err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url,data = {}){
    return new Promise((resolve,reject) => {
        instance.put(url,data)
            .then(response => {
                let result = {};
                if(response.data == null || response.data == undefined){
                    result.status = -2002;
                    result.statusdes ='网络错误';
                    response(result);
                }
                if(response.data.Code==0){
                    result.status = 1;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }else{
                    result.status = response.data.Code;
                    result.data = response.data.Lst;
                    result.statusdes = response.data.Msg;
                }
                resolve(result);
            },err => {
                reject(err)
            })
    })
}


// WEBPACK FOOTER //
// ./src/common/http.js